import { useAuth } from '@hub/auth';
import { HelpLinkButton } from '@hub/components/HelpLinkButton';
import { m } from '@hub/messages';
import { Button, NotFoundPage } from '@platform/ui';
import { Link } from '@tanstack/react-router';
import { HomePaths } from '../../domains/home/route.paths';
import { RouterPaths } from '../routePaths';

export function DefaultNotFoundComponent() {
  const { status } = useAuth();

  return (
    <NotFoundPage
      title={m.commons_error_page_http_not_found()}
      message={m.commons_error_page_message_not_found()}
      actions={
        <>
          <Button size="lg" asChild>
            <Link to={status === 'authenticated' ? HomePaths.home.path : RouterPaths.index.path}>
              {m.commons_error_page_back_to_home()}
            </Link>
          </Button>
          <HelpLinkButton />
        </>
      }
    />
  );
}
